import type { TokenHandshakeHandler } from './types'

const BIRTH_NUMBER_PATTERN = /^\d{6}-\d{3,4}$/

export const openRequestsByBirthNumberHandler: TokenHandshakeHandler = async (
	params,
	{ router }
) => {
	const birthNumber = String(params?.birthNumber || '').trim()

	if (!BIRTH_NUMBER_PATTERN.test(birthNumber)) {
		return {
			error: {
				code: -32602,
				message: 'Invalid params: birthNumber must match format 938434-9999'
			}
		}
	}

	const search = birthNumber.replace('-', '/')

	await router.push({
		name: 'Requests',
		query: {
			state: 'draft',
			search
		}
	})

	return {
		result: 1
	}
}
